import { CmsResource, CmsResourceComponent, ResourceType } from '@insync-students-lib/services/cms/cms-api.types';
import { useMemo } from 'react';
import { getComponent } from './resources.util';
import { ResourceParentType } from '@greatmindsorg/dp-assignments-sdk/dist/engine/dtos/resource-parent-detail.dto';
export interface CmsResourceView {
  type: ResourceType;
  usingComponent: CmsResourceComponent;
  title: string;
  description: string;
  availableLanguages: string[];
  hasMultipleLanguages: boolean;
  isShareable: boolean;
  isAssignable: boolean;
  isForStudents: boolean;
  isDownloadable: boolean;
  hasCaption: boolean;
  caption: string;
  hasCopyright: boolean;
  copyright: string;
  author: string;
  year: string;
  parentType: ResourceParentType | null;
  parentId: string | null;
  resourceId: string | null;
}
export function createResourceView(resource: CmsResource | null, language?: string): CmsResourceView | null {
  if (resource === null) {
    return null;
  }
  const usingComponent = getComponent(resource, language);
  if (!usingComponent) {
    return null;
  }
  const resourceType = usingComponent.componentType;
  const languages = Array.from(new Set(resource.components.map(component => component.language || '')));
  const alternativeTitle = 'alternativeTitle' in usingComponent ? usingComponent.alternativeTitle : '';
  return {
    type: resourceType,
    parentType: usingComponent.parentType || null,
    parentId: usingComponent.parentId || null,
    resourceId: usingComponent.resourceId || null,
    usingComponent,
    title: alternativeTitle || resource.title || '',
    description: resource.description || '',
    availableLanguages: languages,
    hasMultipleLanguages: languages.length > 1,
    isShareable: !!resource.shareable,
    isAssignable: !!resource.assignable,
    isForStudents: !!resource.forStudents,
    isDownloadable: 'downloadable' in usingComponent ? !!usingComponent.downloadable : false,
    hasCaption: 'caption' in usingComponent,
    caption: 'caption' in usingComponent ? usingComponent.caption || '' : '',
    hasCopyright: 'copyrightText' in usingComponent,
    copyright: 'copyrightText' in usingComponent ? usingComponent.copyrightText || '' : '',
    author: 'author' in usingComponent ? usingComponent.author || '' : '',
    year: 'year' in usingComponent ? usingComponent.year || '' : ''
  };
}
export function useResourceView(resource: CmsResource | null, language?: string) {
  return useMemo(() => createResourceView(resource, language), [resource, language]);
}